import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonItem } from '@ionic/react';
import UrpassSelect from './UrpassSelect';
import { currencyFormat } from '../../utils/currency';
import { UrPassProduct } from '../../services/types/urpassapitypes';

type UrpassPassesProps = {
  passes: UrPassProduct[] | undefined;
  selectPass: (p: UrPassProduct) => void;
  icon: string;
};
export default function UrpassPasses({
  passes,
  selectPass,
  icon,
}: UrpassPassesProps) {
  const [t] = useTranslation('global');

  if (!passes) {
    return null;
  }

  return (
    <div className="pt-2">
      {passes.map((pass: UrPassProduct, index: number) => {
        return (
          <div className="pt-2" key={index}>
            <IonItem
              lines="none"
              className="ion-no-padding ion-pt-1 pseudo-select pseudo-select-active"
            >
              <UrpassSelect
                title={pass.name}
                icon={icon}
                midInfo={currencyFormat(pass.price)}
                midAction={() => selectPass(pass)}
                midActionLabel={t('urpassadd.buy')}
              />
            </IonItem>
          </div>
        );
      })}
    </div>
  );
}
